// extracted by mini-css-extract-plugin
export default {"form":"EditarServico_form__MMqRg","areaBtn":"EditarServico_areaBtn__y82Om","btn":"EditarServico_btn__PQ+Tc","btn2":"EditarServico_btn2__-nMeq"};